<template>
  <div class="Nx-main-wrapper Nx-main-wrapper__containing-side-tips">
    <div class="Nx-main Nx-main__next-to-side-tips">
      <div class="Nx-main__content">
        <router-view />
      </div>
    </div>
    <div v-if="hasTips" class="Nx-tips">
      <router-view name="tips" />
    </div>
  </div>
</template>

<script>
import './assets/icons/nexmo-icons.svg';
import { mapActions } from 'vuex';

export default {
  name: 'App',
  methods: {
    ...mapActions(['init']),
  },
  async mounted() {
    this.init();
  },
  computed: {
    hasTips() {
      return this.$route.meta.hasTips;
    },
  }
}
</script>

<style lang="scss">
@import '~@vonagevolta/volta2/dist/css/volta.min.css';
@import '~@vonagevolta/volta2/dist/css/addons/volta-prism.min.css';
@import '~@vonagevolta/volta2/scss/lib/_mediaqueries.scss';
@import '../node_modules/@vonage/vivid/styles/tokens/vivid-2-compat.css';
/* Import Tokens For Light or Dark Theme */
@import '../node_modules/@vonage/vivid/styles/tokens/theme-light.css';
/* (Vonage only) Load Spezia Variable fonts */
@import '../node_modules/@vonage/vivid/styles/fonts/spezia-variable.css';
.Nx-main-wrapper {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;

  @media only screen and (max-width: 575px) {
    padding-top: 60px;
  }

  &--grey {
    background: #d8d8d8;
  }
}

.Nx-tips {
  padding: 25px;
  height: 100vh;
  overflow-y: scroll;
  width: 268px;
  border-left: #efefef 1px solid;
  background: #ffffff;
  @media only screen and (max-width: 1279px) {
    display: none;
  }
  border-radius: 8px;
}

.Nx-tips-home {
  background: #f3f3f5;
  padding: 0;
  border-radius: 24px 0 0 24px;
  width: 270px;
  @media only screen and (max-width: 1279px) {
    display: none;
  }
}

.Nx-main {
  padding-right: 32px;
  height: 100vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  border-width: 0 2px 0 2px;
  flex: 1;
  // This is required for Make payment grey background
  position: relative;

  &.Nx-main__next-to-side-tips {
    @media only screen and (max-width: 2300px) {
      flex: 5;
    }
  }

  @media only screen and (max-width: 1500px) {
    flex: 5;
  }

  @media only screen and (max-width: 575px) {
    height: calc(100vh - 60px);
    padding: 2.4rem;
  }

  &__content {
    width: 100%;
  }
}
</style>
